import { useField } from 'formik';
import { memo } from 'react';

import { ColorPickerMenu, type ColorPickerMenuProps } from '@air/component-color-picker-menu';

export type FormikColorPickerMenuProps = ColorPickerMenuProps & {
  name: string;
};

export const FormikColorPickerMenu = memo(({ name, ...restOfProps }: FormikColorPickerMenuProps) => {
  const [field, _meta, helpers] = useField(name);

  return <ColorPickerMenu {...field} {...restOfProps} onSelect={helpers.setValue} selectedColor={field.value} />;
});

FormikColorPickerMenu.displayName = 'FormikColorPickerMenu';
